import store from '@state/store'

export default [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/encuestas',
    name: 'poll',
    component: () => lazyLoadView(import('@views/poll/pollForm')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/encuestas/:pollId',
    name: 'pollForm',
    component: () => lazyLoadView(import('@views/poll/pollForm')),
    meta: {
      authRequired: true,
      dependency: '/encuestas',
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/lista-encuestas',
    name: 'pollList',
    component: () => lazyLoadView(import('@views/poll/pollList')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/llenar-encuestas',
    name: 'pollFillList',
    component: () => lazyLoadView(import('@views/poll/pollFillList')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/llenar-encuestas/:token',
    name: 'pollExport',
    component: () => lazyLoadView(import('@views/poll/pollFill')),
    meta: {
      authRequired: false,
      dependency: '/llenar-encuestas',
    },
  },
  {
    path: '/formularios',
    name: 'forms',
    component: () => lazyLoadView(import('@views/forms/formsForm')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUssser || {} }),
  },
  {
    path: '/formulario/:formId',
    name: 'form',
    component: () => lazyLoadView(import('@views/forms/formsForm')),
    meta: {
      authRequired: true,
      dependency: '/formularios',
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/lista-formularios',
    name: 'formList',
    component: () => lazyLoadView(import('@views/forms/formList')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/llenar-formularios',
    name: 'formFillList',
    component: () => lazyLoadView(import('@views/forms/formFillList')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/llenar-formulario/:formId',
    name: 'formFill',
    component: () => lazyLoadView(import('@views/forms/formFill')),
    meta: {
      authRequired: true,
      dependency: '/llenar-formularios',
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/variables',
    name: 'variables',
    component: () => lazyLoadView(import('@views/variables/variablesForm')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/variable/:variableId/',
    name: 'variable',
    component: () => lazyLoadView(import('@views/variables/variablesForm')),
    meta: {
      authRequired: true,
      dependency: '/variables',
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/lista-de-variables',
    name: 'variablesList',
    component: () => lazyLoadView(import('@views/variables/variablesList')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/informe-ciudadano',
    name: 'citizenReport',
    component: () => lazyLoadView(import('@views/reports/citizenReport')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/informe-ciudadano/:tipoid/:numeroid',
    name: 'citizenReport',
    component: () => lazyLoadView(import('@views/reports/citizenReport')),
    meta: {
      authRequired: true,
      dependency: '/informe-ciudadano',
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/informe-lista-ciudadano',
    name: 'citizenListReport',
    component: () => lazyLoadView(import('@views/reports/citizenListReport')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/informe-logs-admin',
    name: 'logsReport',
    component: () => lazyLoadView(import('@views/reports/logsReport')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/informe-hogar',
    name: 'homeReport',
    component: () => lazyLoadView(import('@views/reports/homeReport')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/users/',
    name: 'users',
    component: () =>
      lazyLoadView(import('@views/roles_management/users/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/groups/',
    name: 'groups',
    component: () =>
      lazyLoadView(import('@views/roles_management/groups/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/perms/',
    name: 'perms',
    component: () =>
      lazyLoadView(import('@views/roles_management/perms/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/app-sections/',
    name: 'app-sections',
    component: () =>
      lazyLoadView(import('@views/roles_management/app-sections/index')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/roles_management/company-info/',
    name: 'company-info',
    component: () =>
      lazyLoadView(import('@views/roles_management/company-info/index')),
    meta: {
       authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register/:document',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
              name: 'login',
              params: routeTo.params ? routeTo.params : {},
            }
            : { ...routeFrom }
        )
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
